import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const CreateProductReview = createAsyncThunk(
  "/create-review",
  async (data) => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis/webapp/product-reviews/api/v1/create-review`,
        data,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("response review", response);
      return response.data;
    } catch (error) {
      console.error("Error review - ", error);
      throw error;
    }
  }
);

// get products review

export const GetProductReviews = createAsyncThunk(
  "/get-verified-review",
  async (data) => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.post(
        `${baseUrl}vancouverapis//webapp/product-reviews/api/v1/get-verified-review/${data}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );
      console.log("response get reviews", response);
      return response;
    } catch (error) {
      console.error("Error get reviews - ", error);
      throw error;
    }
  }
);
